"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

function beforeGetPanels(context) {
  context.dispatch('GET_PANELS_START');
}

function getPanelsSuccess(context, _ref) {
  var response = _ref.response;
  context.dispatch('GET_PANELS_FINISH', response.data);
}

function getPanelsFailure(context) {
  context.dispatch('GET_PANELS_FAILED');
}

var _default = function _default(config) {
  return {
    serviceName: 'missingPersons.getAllPanels',
    authenticate: true,
    config: {
      method: 'GET',
      url: (0, _get.default)(config, 'endpoints.missingPersons.getAllPanels')
    },
    beforeRequest: beforeGetPanels,
    onSuccess: getPanelsSuccess,
    onError: getPanelsFailure,
    onFailed: getPanelsFailure,
    onTimeout: getPanelsFailure,
    onFatal: getPanelsFailure
  };
};

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(beforeGetPanels, "beforeGetPanels", "/builds/pulse-platform/pulse-missingperson-web-application/src/services/service-configs/get-all-panels/getAllPanels.js");
  reactHotLoader.register(getPanelsSuccess, "getPanelsSuccess", "/builds/pulse-platform/pulse-missingperson-web-application/src/services/service-configs/get-all-panels/getAllPanels.js");
  reactHotLoader.register(getPanelsFailure, "getPanelsFailure", "/builds/pulse-platform/pulse-missingperson-web-application/src/services/service-configs/get-all-panels/getAllPanels.js");
  reactHotLoader.register(_default, "default", "/builds/pulse-platform/pulse-missingperson-web-application/src/services/service-configs/get-all-panels/getAllPanels.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();